var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 2.75H4.125C3.76033 2.75 3.41059 2.89487 3.15273 3.15273C2.89487 3.41059 2.75 3.76033 2.75 4.125V17.875C2.75 18.2397 2.89487 18.5894 3.15273 18.8473C3.41059 19.1051 3.76033 19.25 4.125 19.25H17.875C18.2397 19.25 18.5894 19.1051 18.8473 18.8473C19.1051 18.5894 19.25 18.2397 19.25 17.875V4.125C19.25 3.76033 19.1051 3.41059 18.8473 3.15273C18.5894 2.89487 18.2397 2.75 17.875 2.75ZM9.625 4.8125H12.375C12.5573 4.8125 12.7322 4.88493 12.8611 5.01386C12.9901 5.1428 13.0625 5.31766 13.0625 5.5C13.0625 5.68234 12.9901 5.8572 12.8611 5.98614C12.7322 6.11507 12.5573 6.1875 12.375 6.1875H9.625C9.44266 6.1875 9.2678 6.11507 9.13886 5.98614C9.00993 5.8572 8.9375 5.68234 8.9375 5.5C8.9375 5.31766 9.00993 5.1428 9.13886 5.01386C9.2678 4.88493 9.44266 4.8125 9.625 4.8125ZM10.3125 17.875H5.5V8.25H10.3125V17.875ZM16.5 17.875H11.6875V8.25H16.5V17.875Z",
    fill: "#03154D",
    fillOpacity: 0.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/Classroom.3b232c784fd44a582f8fd0bfcfeb481d.svg";
export { ForwardRef as ReactComponent };